
import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';

const AnimatedNumber = ({ value, duration = 2000, prefix = '', suffix = '', variant = 'h4', ...props }) => {
  const [count, setCount] = useState(0);
  
  useEffect(() => {
    let start = 0;
    const end = parseInt(value);
    
    if (start === end) return;
    
    const totalMilSecDur = parseInt(duration);
    const incrementTime = (totalMilSecDur / end) * 10;
    
    let timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, incrementTime);
    
    return () => {
      clearInterval(timer);
    };
  }, [value, duration]);

  return (
    <Typography variant={variant} {...props}>
      {prefix}{Math.floor(count)}{suffix}
    </Typography>
  );
};

export default AnimatedNumber;